import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import Profile from "../src/components/Profile"
import ShippingTwo from "./pages/ShippingTwoPage"

import ProductDetailsMaterialPage from "./pages/ProductDetailsMaterialPage";
import { AuthProvider } from "./context/AuthContext"; // adjust path as needed

import ComparisonPage from "./components/ComparisonPage";
function App() {
  return (
    <AuthProvider>

      <BrowserRouter>
        <RouteScrollToTop />
        <PhosphorIconInit />

        <Routes>
          <Route path="/profile" element={<Profile />} />

          <Route exact path='/' element={<HomePageOne />} />
          <Route exact path='/index-two' element={<HomePageTwo />} />
          <Route exact path='/index-three' element={<HomePageThree />} />
          <Route exact path='/shop' element={<ShopPage />} />
          <Route
            exact
            path='/product-details'
            element={<ProductDetailsPageOne />}
          />
          <Route
            exact
            path='/product-details-two'
            element={<ProductDetailsPageTwo />}
          />
          <Route
            exact
            path='/product-details-material'
            element={<ProductDetailsMaterialPage />}
          />

          <Route exact path='/cart' element={<CartPage />} />
          <Route exact path='/checkout' element={<CheckoutPage />} />
          <Route exact path='/become-seller' element={<BecomeSellerPage />} />
          <Route exact path='/wishlist' element={<WishlistPage />} />
          <Route exact path='/account' element={<AccountPage />} />
          <Route exact path='/blog' element={<BlogPage />} />
          <Route exact path='/blog-details' element={<BlogDetailsPage />} />
          <Route exact path='/shipping-policy' element={<ShippingTwo />} />

          <Route exact path='/contact' element={<ContactPage />} />
          <Route exact path='/vendor' element={<VendorPage />} />
          <Route exact path='/vendor-details' element={<VendorDetailsPage />} />
          <Route exact path='/vendor-two' element={<VendorTwoPage />} />
          <Route exact path='/comparison' element={<ComparisonPage />} />


          <Route
            exact
            path='/vendor-two-details'
            element={<VendorTwoDetailsPage />}
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>

  );
}

export default App;
